import React from "react";

import { ErrorStateView } from "@common/components/PageStateView/components/ErrorStateView";

export function Error() {
  return (
    <ErrorStateView
      title="There was an error loading page. Try refreshing."
      subtitle="The link you followed may be broken, or the ticket may have been removed."
    />
  );
}
